const MARKETAGENT_ACTIVE_SOURCING = 'Marketagent für karriere.at (2024). Befragt wurden 158 Personalverantwortliche in Österreich, die Active Sourcing nutzen.';
const GA_TOTAL_USERS_JOB_SEARCH = 'Google Analytics (01/2024), Total User auf karriere.at Seiten mit Nutzer*innen mit zumindest einer Jobsuche-Intention.';
const GA_TOTAL_USERS_JOB_SEARCH_MONTHLY = 'Google Analytics (01/2024). Abgerundeter Wert von Total User auf karriere.at Seiten von Nutzer*innen mit zumindest einer Jobsuche-Intention dividiert durch 31 (Tage).';
const GA_03_2025 = 'Google Analytics (03/2025)';

export const indexPage = [
    'Marketagent für karriere.at (2023). Befragt wurden 1.502 erwerbsfähige Personen.',
    GA_TOTAL_USERS_JOB_SEARCH,
    'Marketagent für karriere.at (2024). Befragt wurden 406 Kunden von karriere.at.',
    GA_TOTAL_USERS_JOB_SEARCH_MONTHLY,
    'Eigene Datenerhebung (10/2024)',
    'Marketagent für karriere.at (2023)',
];

export const langeBesetzungsdauer = [
    'Marketagent für karriere.at (08/2022). Befragt wurden 807 Personalverantwortliche in Österreich.',
    'Marketagent für karriere.at (Q3/2024). Befragt wurden 1.503 Erwerbsfähige in Österreich.',
    MARKETAGENT_ACTIVE_SOURCING,
    GA_TOTAL_USERS_JOB_SEARCH_MONTHLY,
    GA_03_2025
];

export const mangelAnBewerbungen = [
    'Marketagent für karriere.at (2023). Befragt wurden 1.025 Erwerbsfähige in Österreich.',
    GA_TOTAL_USERS_JOB_SEARCH,
    GA_TOTAL_USERS_JOB_SEARCH_MONTHLY,
    GA_03_2025
];

export const hoherPersonalbedarf = [
    'Marketagent für karriere.at (08/2022). Befragt wurden 807 Personalverantwortliche in Österreich.',
    GA_TOTAL_USERS_JOB_SEARCH,
    MARKETAGENT_ACTIVE_SOURCING,
];

export const starkerMitbewerb = [
    'Marketagent für karriere.at (2024). Befragt wurden 365 Personalverantwortliche in Österreich.',
    MARKETAGENT_ACTIVE_SOURCING,
    GA_TOTAL_USERS_JOB_SEARCH_MONTHLY,
    GA_03_2025
];
